"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var parse5_1 = require("parse5");

var enums_1 = require("../../enums");

var parser_configuration_1 = require("../parser-configuration");

var parse5utils_1 = require("./parse5utils");

var Parse5RichTextParser =
/** @class */
function () {
  function Parse5RichTextParser() {}

  Parse5RichTextParser.prototype.resolveRichTextField = function (html, fieldName, replacement, config) {
    try {
      // create document
      var documentFragment = parse5_1.parseFragment(html); // get all linked items

      var result = this.processRichTextField(fieldName, this.getChildNodes(documentFragment), replacement, config, {
        links: [],
        linkedItems: [],
        images: []
      });
      var resolvedHtml = parse5_1.serialize(documentFragment);
      return {
        links: result.links,
        linkedItems: result.linkedItems,
        images: result.images,
        resolvedHtml: resolvedHtml
      };
    } catch (error) {
      throw Error('Parsing HTML failed:' + error);
    }
  };

  Parse5RichTextParser.prototype.processRichTextField = function (fieldName, elements, replacement, config, result) {
    var _this = this;

    if (!elements || elements.length === 0) {// there are no more elements
    } else {
      elements.forEach(function (element) {
        if (element.attrs) {
          // process modular content items
          _this.processModularContentItem(element, replacement, config, result); // process links


          _this.processLink(element, replacement, config, result); // process images


          _this.processImage(fieldName, element, replacement, config, result);
        }

        if (element.childNodes) {
          // recursively process all childs
          _this.processRichTextField(fieldName, _this.getChildNodes(element), replacement, config, result);
        }
      });
    }

    return result;
  };

  Parse5RichTextParser.prototype.processImage = function (fieldName, element, replacement, config, result) {
    var attributes = element.attrs;

    if (element.nodeName !== parser_configuration_1.parserConfiguration.imageElementData.nodeName) {
      // node is not an image
      return;
    } // get image id attribute


    var dataImageIdAttribute = attributes.find(function (m) {
      return m.name === parser_configuration_1.parserConfiguration.imageElementData.dataImageId;
    });

    if (!dataImageIdAttribute) {
      // image tag does not have image id attribute
      return;
    } // prepare link object


    var image = {
      imageId: dataImageIdAttribute.value
    }; // add link to result

    result.images.push(image);
    var linkResult = replacement.getImageResult(image.imageId, fieldName); // set url of image

    var srcAttribute = attributes.find(function (m) {
      return m.name === parser_configuration_1.parserConfiguration.imageElementData.srcAttribute;
    });

    if (srcAttribute) {
      srcAttribute.value = linkResult.url;
    }
  };

  Parse5RichTextParser.prototype.processLink = function (element, replacement, config, result) {
    var attributes = element.attrs;

    if (element.nodeName !== parser_configuration_1.parserConfiguration.linkElementData.nodeName) {
      // node is not a link
      return;
    } // get all links which have item it attribute, ignore all other links (they can be regular links in rich text)


    var dataItemIdAttribute = attributes.find(function (m) {
      return m.name === parser_configuration_1.parserConfiguration.linkElementData.dataItemId;
    });

    if (!dataItemIdAttribute) {
      // its either a regular link or the attribute is not defined
      return;
    } // prepare link object


    var link = {
      dataItemId: dataItemIdAttribute ? dataItemIdAttribute.value : ''
    }; // add link to result

    result.links.push(link); // get original link text (the one inside <a> tag from response)

    var originalLinkText = undefined;
    var linkTextNode = element.childNodes[0];

    if (linkTextNode) {
      originalLinkText = linkTextNode.value;
    }

    var linkResult = replacement.getLinkResult(link.dataItemId, originalLinkText || '');
    var useResultAsUrl = true;

    if (typeof linkResult === 'string') {
      // use result as URL
      useResultAsUrl = true;
    } else {
      useResultAsUrl = false;
    }

    if (useResultAsUrl) {
      // assign url to 'href' attribute of the link
      var hrefAttribute = attributes.find(function (m) {
        return m.name === 'href';
      });

      if (!hrefAttribute) {
        // href attribute is missing
        if (config.enableAdvancedLogging) {
          console.warn("Cannot set url '" + linkResult + "' because 'href' attribute is not present in the <a> tag. Please report this issue if you are seeing this. This warning can be turned off by disabling 'enableAdvancedLogging' option.");
        }
      } else {
        // get link url
        var linkUrlResult = typeof linkResult === 'string' ? linkResult : linkResult.asUrl;
        hrefAttribute.value = linkUrlResult ? linkUrlResult : '';
      }
    }

    if (!useResultAsUrl) {
      // replace whole link (<a> tag)
      if (linkResult) {
        // html for link is defined
        var linkHtml = linkResult.asHtml ? linkResult.asHtml : '';

        if (linkHtml) {
          var newNode = parse5_1.parseFragment(parse5utils_1.parse5Utils.createTextNode(''), linkHtml);
          parse5utils_1.parse5Utils.replaceNode(element, newNode.childNodes[0]);
        }
      }
    }
  };

  Parse5RichTextParser.prototype.processModularContentItem = function (element, replacement, config, result) {
    var attributes = element.attrs;
    var typeAttribute = attributes.find(function (m) {
      return m.value === parser_configuration_1.parserConfiguration.modularContentElementData.type;
    });

    if (!typeAttribute) {
      // node is not kentico cloud data type
      return;
    }

    var dataTypeAttribute = attributes.find(function (m) {
      return m.name === parser_configuration_1.parserConfiguration.modularContentElementData.dataType;
    });

    if (!dataTypeAttribute) {
      throw Error("Object tag in rich text field is missing a data type attribute '" + parser_configuration_1.parserConfiguration.modularContentElementData.dataType + "'");
    } // get type of resolving item


    var type;

    if (dataTypeAttribute.value === 'item') {
      type = enums_1.RichTextContentType.Item;
    } else {
      throw Error("Unknown data type '" + type + "' found in rich text field response. ");
    } // get codename of the modular content


    var dataCodenameAttribute = attributes.find(function (m) {
      return m.name === parser_configuration_1.parserConfiguration.modularContentElementData.dataCodename;
    });

    if (dataCodenameAttribute == null) {
      throw Error("The '" + parser_configuration_1.parserConfiguration.modularContentElementData.dataCodename + "' attribute is missing and therefore linked item cannot be retrieved");
    }

    var itemCodename = dataCodenameAttribute.value;
    var linkedItem = {
      dataCodename: dataCodenameAttribute ? dataCodenameAttribute.value : '',
      dataType: dataTypeAttribute ? dataTypeAttribute.value : ''
    }; // add to result

    result.linkedItems.push(linkedItem); // get html

    var resultHtml = replacement.getLinkedItemHtml(itemCodename, type); // replace 'object' tag name

    element.tagName = config.linkedItemWrapperTag; // add classes

    element.attrs.push({
      name: 'class',
      value: config.linkedItemWrapperClasses.map(function (m) {
        return m;
      }).join(' ')
    }); // get serialized set of nodes from HTML

    var serializedChildNodes = parse5_1.parseFragment(resultHtml); // add child nodes

    element.childNodes = serializedChildNodes.childNodes;
  };

  Parse5RichTextParser.prototype.getChildNodes = function (documentFragment) {
    return documentFragment.childNodes;
  };

  return Parse5RichTextParser;
}();

exports.Parse5RichTextParser = Parse5RichTextParser;